const educationBackground = [
    {
        institution: "MAKERERE UNIVERSITY",
        course: "Bsc. TELECOMMUNICATIONS ENGINEERING",
        duration: "2014 - 2019"
    },
    {
        institution: "St. Mary's College, Kisubi",
        course: "A-LEVEL",
        duration: "2012 - 2013"
    }
]

export default educationBackground;
